import React from "react";

import { twClassNames } from "@scripts/react/helpers/twClassNames";

interface ClickableElementProps {
    onClick: () => void;
    icon: string;
    title: string;
    isSelected?: boolean;
    disabled?: boolean;
    hoverClassName?: string;
    iconClassName?: string;
    titleHoverClassName?: string;
    descriptionHoverClassName?: string;
}

export const ClickableElement = ({
    onClick,
    icon,
    title,
    isSelected = false,
    disabled = false,
    hoverClassName = "hover:bg-white hover:border-brand",
    titleHoverClassName = "group-hover:text-gray-800"
}: ClickableElementProps) => {
    return (
        <div
            onClick={disabled ? undefined : onClick}
            className={twClassNames(
                "border--300 group flex cursor-pointer items-center gap-4 rounded-lg border px-5 py-3 transition-all duration-300",
                isSelected && "border-brand bg-tint",
                !disabled && !isSelected && hoverClassName,
                disabled && "cursor-not-allowed opacity-50"
            )}
        >
            <div className="text-base">
                <i
                    className={twClassNames(
                        icon,
                        "fa-fw",
                        isSelected ? "text-brand" : "text-primary",
                        !disabled && !isSelected && "group-hover:text-brand"
                    )}
                />
            </div>
            <div className="flex flex-col">
                <h3
                    className={twClassNames(
                        "text-base font-medium",
                        isSelected ? "text-brand" : "text-primary",
                        !disabled && titleHoverClassName,
                        isSelected && titleHoverClassName.replace(/group-hover:/g, "")
                    )}
                >
                    {title}
                </h3>
            </div>
        </div>
    );
};
